export default "__VITE_ASSET__DT5e9ggQ__"